import { createSlice } from "@reduxjs/toolkit";
import { getReservations } from "../reservations/thunks";
import { getClients } from "../clients/thunks";
import { getDestinations } from "../destinations/thunks";

const initialState = {
    session: null,
    loading: true
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setSession: (state, action) => {
            state.session = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        clearSession: (state) => {
            state.session = null;
        }
    }
});

export const { setSession, setLoading, clearSession } = authSlice.actions;

/**
 * Prefetch the most-used data slices right after authentication.
 * This runs in parallel so data is ready before the user navigates anywhere.
 * Only fetches if the slice is idle (not already loaded from cache).
 */
export const prefetchCriticalData = () => (dispatch, getState) => {
  const state = getState();
  
  // Only prefetch slices that aren't already loaded (from sessionStorage cache)
  if (state.reservation?.status === 'idle') {
    dispatch(getReservations());
  }
  if (state.client?.status === 'idle') {
    dispatch(getClients());
  }
  if (state.destination?.status === 'idle') {
    dispatch(getDestinations());
  }
};

export default authSlice.reducer;